import { useState, useEffect, useRef } from 'react'
import logo from './logo.svg';
import './App.css';

import EditorJS from '@riezler/editorjs'

function App() {

  let editor = useRef(null)
  let [holder, setRef] = useState(null)

  useEffect(() => {
    if (holder === null) return
    editor.current = new EditorJS({ holder })
  }, [holder])

  function destroy() {
    if (editor.current) {
      editor.current
        .isReady
        .then(() => {
          if (editor.current) {
            console.log('Destroy editor')
            editor.current.destroy()
          }
        })
        .catch(console.log)
    }
  }

  return (
    <div className="App">

      <button onClick={destroy}>Destroy</button>
      <div ref={setRef}></div>

    </div>
  );
}

export default App;
